import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
@Component({
  selector: 'app-zone-wise-count',
  templateUrl: './zone-wise-count.component.html',
  styleUrls: ['./zone-wise-count.component.scss']
})
export class ZoneWiseCountComponent implements OnInit {
  zone_wise_data: any;
  is_data_available = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;
  business_type_list: any;
  selected_business_type_id: any;

  constructor(public dialogRef: MatDialogRef<ZoneWiseCountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService) {
    this.is_data_available = false;
    this.httpService.serveZoneWiseOrderedBusinessData().subscribe((data) => {
      console.log(data);
      this.zone_wise_data = data;
      this.business_type_list = data['business_type_list'];
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }


  expandClicked(business_type_id) {
    if (this.selected_business_type_id === business_type_id) {
      this.selected_business_type_id = null;
    } else {
      this.selected_business_type_id = business_type_id;
    }
  }

  closeComponent() {
    this.dialogRef.close();
  }
  ngOnInit() {
  }

}
